import { Box, HStack, StackProps, Text } from "@chakra-ui/react";

import GithubLogo from "@/common/assets/github-logo.svg?react";
import { highlightStringMatch } from "@/common/components/Autocomplete/AutocompleteSelect";
import { GithubRepo } from "@reflag/shared/githubConnectionAPI";

type GithubRepositoryDisplayProps = {
  repository: Pick<GithubRepo, "fullName">;
  search?: string;
  showIcon?: boolean;
} & StackProps;

export function GithubRepositoryDisplay({
  repository,
  search,
  showIcon = true,
  ...rest
}: GithubRepositoryDisplayProps) {
  return (
    <HStack spacing={3} {...rest}>
      {showIcon && <GithubLogo height="24px" width="24px" />}
      <Box>
        <Text>
          {search
            ? highlightStringMatch(repository.fullName, search ?? "")
            : repository.fullName}
        </Text>
      </Box>
    </HStack>
  );
}
